import React from 'react'
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'
import {
  MOBILE_BOTTOM_SHEET_DESTRUCTIVE_ROW_CLASS,
  MOBILE_BOTTOM_SHEET_ROW_CLASS,
  MobileBottomSheet,
} from './MobileBottomSheet'

const utilityDestinations = [
  { label: 'Drafts', path: '/drafts' },
  { label: 'Prints', path: '/prints' },
  { label: 'Account', path: '/account' },
  { label: 'Support', path: '/support' },
] as const

export interface MobileAuthenticatedUtilitySheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  resolvedName: string
  userInitial: string
  avatarUrl?: string | null
  email?: string | null
  onDestinationClick: (path: string) => void
  onSignOutClick: () => void | Promise<void>
}

export const MobileAuthenticatedUtilitySheet: React.FC<
  MobileAuthenticatedUtilitySheetProps
> = ({
  open,
  onOpenChange,
  resolvedName,
  userInitial,
  avatarUrl,
  email,
  onDestinationClick,
  onSignOutClick,
}) => {
  return (
    <MobileBottomSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Account menu"
    >
      <div className="space-y-5">
        <div className="mb-5 flex items-center gap-3">
          <Avatar className="h-10 w-10">
            {avatarUrl ? (
              <AvatarImage src={avatarUrl} alt={resolvedName} />
            ) : null}
            <AvatarFallback className="bg-primary-400 text-background-50 text-sm font-medium">
              {userInitial}
            </AvatarFallback>
          </Avatar>
          <div className="min-w-0">
            <p className="truncate font-sans text-fs-400 font-medium text-ink-700">
              {resolvedName}
            </p>
            <p className="truncate font-sans text-fs-300 text-ink-500">
              {email ?? 'Signed in'}
            </p>
          </div>
        </div>

        <nav
          aria-label="Account destinations"
          className="divide-y divide-[rgba(36,34,30,0.06)]"
        >
          {utilityDestinations.map((destination) => (
            <button
              key={destination.path}
              type="button"
              onClick={() => onDestinationClick(destination.path)}
              className={MOBILE_BOTTOM_SHEET_ROW_CLASS}
            >
              <span>{destination.label}</span>
            </button>
          ))}
        </nav>

        <div className="border-t border-[rgba(36,34,30,0.06)] pt-2">
          <button
            type="button"
            onClick={() => void onSignOutClick()}
            className={MOBILE_BOTTOM_SHEET_DESTRUCTIVE_ROW_CLASS}
          >
            <span>Sign out</span>
          </button>
        </div>
      </div>
    </MobileBottomSheet>
  )
}

export default MobileAuthenticatedUtilitySheet
